
import { defineComponent } from 'vue'
import LeftDrawer from './Header.LeftDrawer.vue'
import AccountDropdownMenu from './Header.AccountDropdownMenu.vue'
import ConfigurationDropdownMenu from './Header.ConfigurationDropdownMenu.vue'
import { LOCAL_STORAGE_CONSTANTS } from '@/constants/localstorage.contstants'

export default defineComponent({
  name: 'Header',
  components: {
    AccountDropdownMenu,
    ConfigurationDropdownMenu,
    LeftDrawer
  },
  emits: ['toggled'],
  data() {
    const isEmployeeFlag = localStorage.getItem(LOCAL_STORAGE_CONSTANTS.isEmployee)
    const isEmployee = isEmployeeFlag !== null && isEmployeeFlag === 'true'

    return {
      drawerOpen: false,
      isEmployee
    }
  },
  computed: {
    showLinks(): boolean {
      return this.$route.meta.requiresLogin
    }
  },
  mounted() {
    window.addEventListener(LOCAL_STORAGE_CONSTANTS.eventName, this.onLocalStorageChanged)
  },
  unmounted() {
    window.removeEventListener(LOCAL_STORAGE_CONSTANTS.eventName, this.onLocalStorageChanged)
  },
  methods: {
    onLocalStorageChanged(): void {
      const isEmployeeFlag = localStorage.getItem(LOCAL_STORAGE_CONSTANTS.isEmployee)
      this.isEmployee = isEmployeeFlag !== null && isEmployeeFlag === 'true'
    },
    toggleDrawer(): void {
      this.drawerOpen = !this.drawerOpen
    }
  }
})
